import { t } from '@/i18n';
import { cn } from '@/lib/utils';

/**
 * The grey "Coming soon" pill the plan ladder and the integrations page
 * already show, for public claims whose feature is not live yet
 * (config/featureAvailability.ts). Reuses the existing catalog string.
 */
export function ComingSoonBadge({ className }: { className?: string }): JSX.Element {
  return (
    <span
      data-testid="coming-soon-badge"
      className={cn('ml-2 inline-block whitespace-nowrap rounded-full bg-gray-100 px-2 py-0.5 align-middle text-xs font-medium text-gray-500', className)}
    >
      {t('billing.plans.comingSoon')}
    </span>
  );
}
